// Based on https://github.com/mbertheau/jquery.django-formset
var __hasProp = {}.hasOwnProperty,
    __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

/** @typedef {Object} DjangoFormsetOptions
 * @property {string=} prefix Prefiks formsetu. Domyślnie odgadywany z pustego formularza.
 * @property {string} deleteButtonText Surowy HTML przycisku "usuń"
 * @property {string} deleteButtonClass CSS Query (nie klasa!) przycisku "usuń", wyklucza się z `deleteButtonText`
 * @property {boolean=true} handleOrderInput Czy ukrywać i uzupełniać pole ORDER?
 * @property {string} formNumberContainer CSS Query wskazujące element, którego tekst przedstawia numer formularza
 * @property {DjangoFormsetHandlers} on Event handlery
 */

/** @typedef {Object} DjangoFormsetHandlers
 * @property {function (event, form)} formInitialized Wywoływany po uruchomieniu formsetu i dla każdego dodanego formularza
 */

(function($) {
    'use strict';

    var FormsetError;
    /** @param {DjangoFormsetOptions} options */
    $.fn.djangoFormset = function (options) {
        return new $.fn.djangoFormset.Formset(this, options);
    };
    FormsetError = (function(_super) {
        __extends(FormsetError, _super);

        function FormsetError() {
            return FormsetError.__super__.constructor.apply(this, arguments);
        }

        return FormsetError;

    })(Error);
    $.fn.djangoFormset.Formset = (function() {
        function Formset(base, options) {
            var deletedForms, forms, inputName, placeholderPos;
            this.opts = $.extend({}, $.fn.djangoFormset.defaultOptions, options);
            if (base.length === 0) {
                throw new FormsetError("Empty selector.");
            }
            this.template = base.filter("." + this.opts.formTemplateClass);
            if (this.template.length === 0) {
                throw new FormsetError("Can't find template (looking for ." + this.opts.formTemplateClass + ")");
            }
            inputName = this.template.find("input,select,textarea").first().attr('name');
            if (!inputName) {
                throw new FormsetError("Can't figure out form prefix because there's no form input in the form template. Please add one.");
            }
            if (this.opts.prefix) {
                this.prefix = this.opts.prefix;
            } else {
                placeholderPos = inputName.indexOf('-__prefix__');
                if (placeholderPos === -1) {
                    throw new FormsetError("Can't figure out form prefix from template because it doesn't contain '-__prefix__'.");
                }
                this.prefix = inputName.substring(0, placeholderPos);
            }
            this.totalForms = $("#id_" + this.prefix + "-TOTAL_FORMS");
            this.initialFormsElem = $("#id_" + this.prefix + "-INITIAL_FORMS");
            const maxNumFormsRaw = $("#id_" + this.prefix + "-MAX_NUM_FORMS").val();
            this.maxNumForms = maxNumFormsRaw ? parseInt(maxNumFormsRaw, 10) : null;
            if (this.totalForms.length === 0) {
                throw new FormsetError("Management form field 'TOTAL_FORMS' not found for prefix " + this.prefix + ".");
            }
            forms = base.not("." + this.opts.formTemplateClass);
            this.initialForms = forms.length;
            $(this).on(this.opts.on);
            this.forms = forms.map((function(_this) {
                return function(index, element) {
                    var newForm;
                    newForm = new _this.opts.formClass($(element), _this, index);
                    $(_this).trigger("formInitialized", [newForm]);
                    return newForm;
                };
            })(this));
            if (this.forms.length !== parseInt(this.totalForms.val())) {
                console.error("TOTAL_FORMS is " + (this.totalForms.val()) + ", but " + this.forms.length + " non-template elements found in passed selection.");
            }
            deletedForms = this.forms.filter(function() {
                return this.deleteInput.val();
            });
            deletedForms.each(function() {
                return this["delete"]();
            });
            this.insertAnchor = base.not("." + this.opts.formTemplateClass).last();
            if (this.insertAnchor.length === 0) {
                this.insertAnchor = this.template;
            }
            return;
        }

        Object.defineProperties(Formset.prototype, {
            visibleForms: {
                get: function getVisibleForms() {
                    return  this.forms.filter(function () {
                        return this.isVisible()
                    });
                }
            },
            canAddForm: {
                get: function getCanAddForm() {
                    if (this.maxNumForms) {
                        return this.visibleForms.length < this.maxNumForms;
                    } else {
                        return true;
                    }
                }
            },
        })

        /**
         * @param {Object=} opts
         * @param {jQuery=} opts.template - pusty formularz do skopiowania, domyślnie znaleziony w formsecie
         * @param {boolean=false} opts.initial - czy ten formularz był obecny przy ładowaniu strony?
         * @return {Form}
         */
        Formset.prototype.addForm = function(opts) {
            var newForm, newFormElem;
            if (!this.canAddForm)
                return;
            opts = opts || {};
            if (opts.initial) {
                this.initialForms += 1;
                this.initialFormsElem.val(this.initialForms);
            }
            var template = opts.template || this.template;
            newFormElem = template.clone().removeClass(this.opts.formTemplateClass).attr("id", null);
            newForm = new this.opts.formClass(newFormElem, this, parseInt(this.totalForms.val()));
            newFormElem.insertAfter(this.insertAnchor.last());
            this.insertAnchor = newFormElem;
            this.forms.push(newForm);
            this.totalForms.val(parseInt(this.totalForms.val()) + 1);
            $(this).trigger("formInitialized", [newForm]);
            $(this).trigger("formAdded", [newForm]);
            this.updateFormsVisibleIndexes();
            newFormElem.find("input,textarea,select").first().focus();
            return newForm;
        };

        Formset.prototype.deleteForm = function(index) {
            var form;
            form = this.forms[index];
            form["delete"]();
            this.updateFormsVisibleIndexes();
        };

        Formset.prototype.handleFormRemoved = function(index) {
            var form, i, _i, _len, _ref;
            this.totalForms.val(parseInt(this.totalForms.val()) - 1);
            if (this.forms[index].isInitial()) {
                this.initialForms -= 1;
                this.initialFormsElem.val(this.initialForms);
            }
            this.forms.splice(index, 1);
            _ref = this.forms;
            for (i = _i = 0, _len = _ref.length; _i < _len; i = ++_i) {
                form = _ref[i];
                form._updateFormIndex(i);
            }
            if (this.forms.length === 0) {
                this.insertAnchor = this.template;
            } else {
                this.insertAnchor = this.forms[this.forms.length - 1].elem;
            }
        };

        Formset.prototype.updateFormsVisibleIndexes = function () {
            var form, i, currentNumber = 1;
            if (this.opts.formNumberContainer === undefined) return;
            for (i = 0; i < this.forms.length; i = ++i) {
                form = this.forms[i];
                const form_elem = form.elem;
                if (form.isVisible()) {
                    form_elem.find(this.opts.formNumberContainer)
                        .text(currentNumber.toString());
                    if (this.opts.handleOrderInput)
                        form.orderInput.val(currentNumber);
                    currentNumber++;
                }

            }
        }

        return Formset;

    })();
    $.fn.djangoFormset.Form = (function() {
        function Form(elem, formset, index) {
            var isInitial;
            this.elem = elem;
            this.formset = formset;
            this.index = index;
            this.elem.data('djangoFormset.Form', this);
            if (this.index !== void 0) {
                this._initFormIndex(this.index);
            }
            this.reinit();
            if (formset.opts.handleOrderInput)
                this.orderInput.hide();

            if (this.deleteInput.length > 0 || !this.isInitial()) {
                this._replaceDeleteCheckboxWithButton();
            }
        }

        Form.prototype.reinit = function () {
            this.deleteInput = this.field('DELETE');
            this.orderInput = this.field('ORDER');
        };

        Form.prototype.isInitial = function () {
            return this.index < this.formset.initialForms;
        };

        Form.prototype.getDeleteButton = function() {
            if (this.formset.opts.deleteButtonClass !== undefined) {
                return this.elem.find(this.formset.opts.deleteButtonClass);
            }
            return $("<button type='button' class='btn btn-danger'> " + this.formset.opts.deleteButtonText + " </button>");
        };

        Form.prototype.insertDeleteButton = function() {
            if (this.deleteInput.length > 0) {
                this.deleteInput.after(this.deleteButton);
            } else {
                (this.elem.is('TR') ? this.elem.children().last() : this.elem.is('UL') || this.elem.is('OL') ? this.elem.append('li').children().last() : this.elem).append(this.deleteButton);
            }
        };

        Form.prototype.isVisible = function () {
            return !this.elem.hasClass('deleted');
        };

        Form.prototype["delete"] = function(opts) {
            var opts = opts || {};
            var isInitial, forceDestroy = !!opts.forceDestroy;
            isInitial = this.isInitial();
            if (this.deleteInput.length === 0 && isInitial) {
                console.warn("Tried do delete non-deletable form " + this.formset.prefix + " #" + this.index + ".");
                return;
            }
            if (isInitial && !forceDestroy) {
                if (this.deleteInput.length > 0) {
                    this.deleteInput.val('on');
                    this.elem.addClass('deleted');
                }
                this.hide();
            } else {
                this.elem.remove();
                this.formset.handleFormRemoved(this.index);
            }
            this.formset.updateFormsVisibleIndexes();
            $(this.formset).trigger("formDeleted", [this]);
        };

        Form.prototype.hide = function() {
            return this.elem.hide();
        };

        Form.prototype.field = function(name) {
            return this.elem.find("[name='" + this.formset.prefix + "-" + this.index + "-" + name + "']");
        };

        /**
         * @param name - nazwa pola w formularzu
         * @return {string} - nazwa pola wzbogacona o prefix formularza
         */
        Form.prototype.addPrefix = function(name) {
            return this.formset.prefix + "-" + this.index + "-" + name;
        };

        Form.prototype.prev = function() {
            var form, _i, _ref;
            _ref = this.formset.forms.slice(0, +(this.index - 1) + 1 || 9e9);
            for (_i = _ref.length - 1; _i >= 0; _i += -1) {
                form = _ref[_i];
                if (form.elem.is(':visible')) {
                    return form;
                }
            }
        };

        Form.prototype._replaceDeleteCheckboxWithButton = function() {
            var label, newDeleteInput;
            if (this.deleteInput.length > 0) {
                newDeleteInput = $("<input type='hidden' name='" + (this.deleteInput.attr('name')) + "' id='" + (this.deleteInput.attr('id')) + "' value='" + (this.deleteInput.is(':checked') ? 'on' : '') + "'/>");
                label = this.elem.find("label[for='" + (this.deleteInput.attr('id')) + "']");
                if (label.has(this.deleteInput).length > 0) {
                    label.replaceWith(newDeleteInput);
                } else {
                    label.remove();
                    this.deleteInput.replaceWith(newDeleteInput);
                }
                this.deleteInput = newDeleteInput;
            }
            this.deleteButton = this.getDeleteButton();
            this.deleteButton.on('click', this.formset.opts.onDeleteConstructor(this));
            if (this.formset.opts.deleteButtonClass === undefined) {
                this.insertDeleteButton();
            }
        };

        Form.prototype._replaceFormIndex = function(oldIndexPattern, index) {
            var newPrefix, prefixRegex, _replaceFormIndexElement;
            this.index = index;
            prefixRegex = new RegExp("" + this.formset.prefix + "-" + oldIndexPattern);
            newPrefix = "" + this.formset.prefix + "-" + index;
            _replaceFormIndexElement = function(elem) {
                var attributeName, attributeNames, attributeNamesByTagName, tagName, _i, _len, _results;
                attributeNamesByTagName = {
                    input: ['id', 'name'],
                    select: ['id', 'name'],
                    textarea: ['id', 'name'],
                    label: ['for'],
                    div: ['id'],
                    '*': ['href', 'data-target']
                };
                tagName = elem.get(0).tagName;
                attributeNames = [];
                if (tagName.toLowerCase() in attributeNamesByTagName) {
                    attributeNames = attributeNamesByTagName[tagName.toLowerCase()];
                }
                attributeNames.push.apply(attributeNames, attributeNamesByTagName['*']);
                _results = [];
                for (_i = 0, _len = attributeNames.length; _i < _len; _i++) {
                    attributeName = attributeNames[_i];
                    if (elem.attr(attributeName)) {
                        _results.push(elem.attr(attributeName, elem.attr(attributeName).replace(prefixRegex, newPrefix)));
                    } else {
                        _results.push(void 0);
                    }
                }
                return _results;
            };
            _replaceFormIndexElement(this.elem);
            this.elem.find('input, select, textarea, label, div').each(function() {
                _replaceFormIndexElement($(this));
            });
        };

        Form.prototype._initFormIndex = function(index) {
            this._replaceFormIndex("__prefix__", index);
        };

        Form.prototype._updateFormIndex = function(index) {
            this._replaceFormIndex('\\d+', index);
        };

        return Form;

    })();
    $.fn.djangoFormset.defaultOptions = {
        formTemplateClass: 'empty-form',
        formClass: $.fn.djangoFormset.Form,
        deleteButtonText: 'Delete',
        deleteButtonClass: undefined,
        onDeleteConstructor: (function(_this) {
            return function(event) {
                return _this["delete"]();
            };
        }),
        formNumberContainer: undefined,
        handleOrderInput: true,
    };
    $.djangoFormset = {
    };
})(jQuery);



// WEBPACK FOOTER //
// ./weekly/static/js/django-formset.js